import React from 'react';
import { Link } from 'react-router-dom';

import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export type AdminDrawerLinkProps = {
  label: string;
  to: string;
  icon?: React.ReactNode;
  nested?: boolean;
  testId?: string;
};

export const AdminDrawerLink: React.VFC<AdminDrawerLinkProps> = ({ label, to, icon, nested: isNested, testId = 'admin-driver-link' }) => {
  const { classes, cx } = useStyles();
  const selected = window.location.pathname === to;

  return (
    <ListItemButton
      component={Link}
      to={to}
      classes={{
        gutters: classes.gutters,
        root: classes.root
      }}
      selected={selected}
      className={isNested ? classes.nested : undefined}
      data-testid={testId}
    >
      {icon && (
        <ListItemIcon className={classes.icon}>
          {icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={label}
        primaryTypographyProps={{
          className: cx(
            classes.itemText,
            { [classes.itemSelected]: selected }
          )
        }}
      />
    </ListItemButton>
  );
};


export type AdminDrawerButtonProps = {
  label: React.ReactNode;
  icon?: React.ReactNode;
  nested?: boolean;
  testId?: string;
  onClick: () => void;
};


export const AdminDrawerButton: React.VFC<AdminDrawerButtonProps> = ({ label, icon, nested: isNested, onClick, testId = 'admin-driver-link' }) => {
  const { classes } = useStyles();

  return (
    <ListItemButton
      classes={{
        gutters: classes.gutters,
        root: classes.root
      }}
      className={isNested ? classes.nested : undefined}
      data-testid={testId}
      onClick={onClick}
    >
      {icon && (
        <ListItemIcon className={classes.icon}>
          {icon}
        </ListItemIcon>
      )}
      <ListItemText primary={label}/>
    </ListItemButton>
  );
};

const useStyles = makeStyles<void, 'itemSelected'>({ name: 'AdminDrawerMenu' })((theme, _params, classes) => ({
  gutters: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  itemSelected: {
  },
  itemText: {
    color: theme.palette.text.secondary,
    fontSize: '14px',
    display: 'inline-block',
    fontWeght: 450,
    borderBottom: '2px solid transparent',
    [`&.${classes.itemSelected}`]: {
      borderBottom: `2px solid ${theme.palette.secondary.main}`,
      color: theme.palette.text.primary,
    }
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  root: {
    '&.Mui-selected': {
      backgroundColor: 'unset',
    }
  },
  icon: {
    marginRight: theme.spacing(-2),
  },
}));
